import { Grade, Module } from 'src/types/type'

import { Tag } from '@suntex.fim/ui'

import { getIndividualCount } from './RenderGradeContent'

interface SuggestContentSidebarProps {
  filteredResults: (Grade | Module)[]
  selectedModule: Module
  handleSelectModuleClick: (module: Module) => void
  checkedModulesAndClusters: {
    [key: string]: boolean
  }
}

function getCountOfCheckedItemsByModule(obj: { [key: string]: boolean }): {
  [moduleName: string]: number
} {
  const moduleCounts: { [moduleName: string]: number } = {}

  // Iterate over each key in the object
  Object.keys(obj).forEach((key) => {
    // Check if the key starts with 'Module-'
    if (key.startsWith('Module-')) {
      const cleanedString = key.slice(7)
      const match = cleanedString.split('-')
      const moduleName = match[0]?.split(':')[0] || ''
      // If the value is true, increment the count for that game
      if (obj[key] === true) {
        if (!moduleCounts[moduleName]) {
          moduleCounts[moduleName] = 1
        } else {
          moduleCounts[moduleName] += 1
        }
      }
    }
  })

  return moduleCounts
}

function RenderModuleContent({
  filteredResults,
  handleSelectModuleClick,
  selectedModule,
  checkedModulesAndClusters
}: SuggestContentSidebarProps) {
  const countOfModule = getCountOfCheckedItemsByModule(
    checkedModulesAndClusters
  )
  return (
    <div className="suggest-content__sidebar-module-group">
      {filteredResults.length > 0 ? (
        (filteredResults as Module[]).map((module: Module) => {
          const count =
            getIndividualCount(countOfModule, String(module.module)) || 0
          return (
            <ul className="module-list" key={String(module.module)}>
              <button
                type="button"
                className={`module-list-item ${
                  selectedModule.module === module.module ? 'active' : ''
                }`}
                onClick={() => handleSelectModuleClick(module)}
              >
                <span className="item-desc">{module.module}</span>
                {count > 0 && (
                  <Tag label={count} className="suggest-content-tag" />
                )}
              </button>
            </ul>
          )
        })
      ) : (
        <p>No results found.</p>
      )}
    </div>
  )
}

export default RenderModuleContent
